import { Routes } from '@angular/router';
import { coreRoutes } from '@next/core-lib/app';
import { CustomerGuard } from '@next/core-lib/relationships';

import { PageTitles } from './page-titles';
import { ProprietaryFertilizersOverviewComponent } from './proprietary-fertilizers-overview/proprietary-fertilizers-overview.component';

export const appRoutes: Routes = [
  {
    path: '',
    component: ProprietaryFertilizersOverviewComponent,
    canActivate: [CustomerGuard],
    data: {
      pageTitle: PageTitles.proprietaryFertilizersOverview,
    },
  },
  ...coreRoutes,
];
